import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Building2, RefreshCw, DollarSign, Phone, Mail, MapPin } from 'lucide-react';

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50">
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4 cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="/estate-flow-logo.png" 
                alt="Estate Flow Logo" 
                className="h-14 w-auto"
              />
              <div>
                <span className="text-2xl font-bold text-gray-900">Estate Flow</span>
                <p className="text-xs text-gray-500 -mt-1">Where Property Meets Simplicity</p>
              </div>
            </div>
            <Button variant="ghost" onClick={() => navigate('/')}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <div className="p-4 bg-emerald-100 rounded-full">
                <RefreshCw className="h-12 w-12 text-emerald-600" />
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-2">Return & Refund Policy</h1>
            <p className="text-gray-600">Sebastian Alliance Group LLC</p>
            <p className="text-sm text-gray-500 mt-2">Last Updated: December 3, 2024</p>
          </div>

          <div className="prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7-Day Money-Back Guarantee</h2>
              <div className="bg-emerald-50 p-6 rounded-lg border-l-4 border-emerald-600">
                <p className="text-gray-700 leading-relaxed font-semibold mb-2">
                  New customers receive a full refund within 7 days of purchase
                </p>
                <ul className="list-disc pl-6 space-y-1 text-gray-700">
                  <li>Full refund of subscription fee</li>
                  <li>No questions asked</li>
                  <li>Applies to first-time subscribers</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Customer Support</h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-3">
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-emerald-600" />
                  <div>
                    <p className="font-semibold text-gray-800">Email</p>
                    <p className="text-gray-700">ecommerce@sebasalliance.net</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-emerald-600" />
                  <div>
                    <p className="font-semibold text-gray-800">Phone</p>
                    <p className="text-gray-700">1-877-268-4779</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="h-5 w-5 text-emerald-600" />
                  <div>
                    <p className="font-semibold text-gray-800">Mailing Address</p>
                    <p className="text-gray-700">Sebastian Alliance Group LLC<br />101 N.E. 3rd Ave, STE 1500<br />Fort Lauderdale, Florida 33301</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Transaction Details</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                All transaction confirmations include:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Processing date and time</li>
                <li>Company name: Sebastian Alliance Group LLC</li>
                <li>Transaction amount in USD</li>
                <li>Authorization number</li>
                <li>Order number</li>
                <li>Service description</li>
              </ul>
            </section>

            <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded">
              <p className="font-semibold text-gray-800 mb-2">For Transaction Disputes:</p>
              <p className="text-gray-700">Email: ecommerce@sebasalliance.net</p>
              <p className="text-gray-700">Phone: 1-877-268-4779</p>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-gray-400">© 2025 Sebastian Alliance Group LLC. All Rights Reserved.</p>
          <p className="text-gray-500 text-sm mt-2">Registered in the United States | Transaction Currency: USD</p>
        </div>
      </footer>
    </div>
  );
};

export default RefundPolicy;
